<template>
    <div class="hello">
        <h1>{{ msg }}</h1>
        <p>This site is currently under construction.</p>
        <p>
            We're working hard to bring you innovative and compelling content.
        </p>
        <p>
            In the meantime you can see what we're up to by following us on
            social media.
        </p>

        <h3>Social Media</h3>
        <ul>
            <li>
                <a
                    href="https://www.instagram.com/Baddstories/"
                    target="_blank"
                    rel="noopener"
                    >instagram</a
                >
            </li>

            <li>
                <a
                    href="https://vimeo.com/baddstories"
                    target="_blank"
                    rel="noopener"
                    >vimeo</a
                >
            </li>

            <li>
                <a
                    href="https://twitter.com/Baddstories"
                    target="_blank"
                    rel="noopener"
                    >twitter</a
                >
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'HelloWorld',
    props: {
        msg: String
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
    margin: 40px 0 0;
}

ul {
    list-style-type: none;
    padding: 0;
}

li {
    display: inline-block;
    margin: 0 10px;
}

a {
    color: #ed002f;
}
</style>
